import { FilterList, Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { AutocompleteDropdownConfig } from './filter-config';
import { I18n } from 'common/i18n';
import { changeCategory } from 'common/components/AssetBrowser/actions/filters';
import { FilterType } from './types';
import { FilterScope, getScope } from './translations';
import { IBaseListDropdownOption } from '@tylertech/forge/esm/list-dropdown/list-dropdown-constants';
import { getFilteredOptions } from './filter-helper';

const scope = getScope(FilterScope.Category);

/**
 *  Type inferred from returned data.
 */
type DomainCategory = {
  category: string;
  children: DomainCategory[];
};

/**
 * Converts Domain Category to Dropdown option
 */
const itemToOption = (item: DomainCategory) => ({
  label: item.category,
  value: item.category,
});

const getCategoryOptions = (
  input: string,
  list: DomainCategory[] = [],
): IBaseListDropdownOption<string | null>[] => {
  const allOptions = list.flatMap((item) => [itemToOption(item), ...item.children.map(itemToOption)]);

  return getFilteredOptions(allOptions, input);
};

export const categoryConfigs: AutocompleteDropdownConfig<DomainCategory> = {
  filterName: Filters.Category,
  label: I18n.t('label', { scope }),
  placeholder: I18n.t('placeholder', { scope }),
  filterCallback: getCategoryOptions,
  dispatchAction: changeCategory,
  filterType: FilterType.AutocompleteDropdown,
  filterListName: FilterList.DomainCategories,
};
